import type { Test, FilterRule } from '@/data'
import api from '..'

export interface TestPayload {
  name: string
  type: 'lead_flow'
  status?: 'active' | 'paused' | 'archived'
  base_flow_id: number | null
  flows: {
    flow_id: string
    traffic_percentage: number
  }[]
  triggers?: {
    target: FilterRule['target']
    parameter_name: string
    comparator: FilterRule['comparator']
    value: string
    ordinal: number
  }[]
}

export async function createTest(payload: TestPayload): Promise<Test> {
  const res = await api.post('/flow_experiments', payload)
  return res.data.data
}
